import { Link } from 'react-router-dom';
import { useTranslation } from '@/components/i18n/TranslationProvider';
import { cn } from '@/lib/utils';

export default function AuthLegalNotice({ context = 'signup', className }) {
  const { t } = useTranslation();
  const intro = context === 'social'
    ? t('auth.legal.social_intro')
    : t('auth.legal.signup_intro');

  return (
    <p className={cn('text-xs leading-5 text-white/55', className)}>
      {intro}{' '}
      <Link
        to="/legal/terms-of-service"
        className="font-medium text-cyan-300 underline-offset-4 hover:text-cyan-100 hover:underline"
      >
        {t('auth.legal.terms')}
      </Link>{' '}
      {t('auth.legal.privacy_connector')}{' '}
      <Link
        to="/legal/privacy-policy"
        className="font-medium text-cyan-300 underline-offset-4 hover:text-cyan-100 hover:underline"
      >
        {t('auth.legal.privacy')}
      </Link>.
    </p>
  );
}
